import { render, staticRenderFns } from "./PanelInvoiceRemoveLabelInfo.vue?vue&type=template&id=36578a13&scoped=true&"
import script from "./PanelInvoiceRemoveLabelInfo.vue?vue&type=script&lang=js&"
export * from "./PanelInvoiceRemoveLabelInfo.vue?vue&type=script&lang=js&"
import style0 from "./PanelInvoiceRemoveLabelInfo.vue?vue&type=style&index=0&id=36578a13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36578a13",
  null
  
)

export default component.exports